import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  VStack,
  Text,
  Image,
  Box,
} from '@chakra-ui/react';
import getProfilePic from '../../../helpers/getProfilePic';
import { useTranslation } from 'react-i18next';

export default function ModalMostrarTitulares({
  isOpen,
  onClose,
  titulares,
  postventa,
}) {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
    >
      <ModalOverlay
        bg="blackAlpha.400"
        backdropFilter="blur(5px) "
      />
      <ModalContent>
        <ModalHeader>
        {t('POSTSELL_HOLDERS')} {postventa.nombre} {postventa.apellidos}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {titulares.length > 0 ? (
            <VStack
              spacing={4}
              align="stretch"
              overflowY="auto"
              maxHeight="380px"
            >
              {titulares.map((titular) => (
                <BoxTitular
                  key={titular.id}
                  titular={titular}
                />
              ))}
            </VStack>
          ) : (
            <h3>
              {t('NO_HOLDERS_ASSIGNED')}
            </h3>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

const BoxTitular = ({ titular }) => {
  const { t } = useTranslation();
  const [profilePic, setProfilePic] = useState();
  useEffect(() => {
    (async () => {
      const data = await getProfilePic(titular.id);

      if (data) {
        setProfilePic(data);
      } else {
        setProfilePic(null);
      }
    })();
  }, [titular]);

  return (
    <Box
      key={titular.id}
      borderWidth="1px"
      p={4}
      borderRadius="md"
    >
      {profilePic ? (
        <Image
          src={profilePic}
          alt={`${titular.nombre} ${titular.apellidos}`}
          boxSize="150px"
          objectFit="cover"
          borderRadius="md"
        />
      ) : (
        <Box
          width="150px"
          height="150px"
          backgroundColor="gray.200"
          display="flex"
          alignItems="center"
          justifyContent="center"
          borderRadius="md"
        >
          <Text
            fontSize="lg"
            fontWeight="bold"
          >
            {t('WITHOUT_PHOTO')}
          </Text>
        </Box>
      )}
      <Text fontWeight="bold">{`${titular.nombre} ${titular.apellidos}`}</Text>
      <Text>{`${t('EMAIL_LABEL')}: ${titular.correo}`}</Text>
      <Text>{`${t('PHONE_NUMBER_LABEL')} ${
        titular.numeroTel || t('NO_PHONE_NUMBER')
      }`}</Text>
    </Box>
  );
};
